import * as React from 'react'

import type AccessGroup from 'modules/core/store/models/AccessGroup'

export const SurveyParticipantsContext = React.createContext<{
  fetchRespondents: () => void
  accessGroup?: AccessGroup | null | undefined
}>({
  fetchRespondents: () => undefined,
  accessGroup: null,
})
